<template>
  <div
    id="app"
    :class="textDirection || 'ltr'"
  >
    <AppHeader />
    <Grants />
  </div>
</template>

<script>
import AppHeader from './components/AppHeader.vue';
import Grants from './components/Grants.vue';
import lang from './language-keys';

export default {
  name: 'App',
  components: {
    AppHeader,
    Grants
  },
  data: function () {
    return {
      textDirection: ''
    };
  },
  mounted() {
    this.textDirection = lang.getTextDirection();
  }
};
</script>

<style>
body {
  font-family: Roboto, Raleway, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #404259;
  background-color: #f3f3f3;
  padding: 0;
  margin: 0;
}
div#app {
  margin-bottom: 36px;
}
div,
button {
  border-radius: 4px;
}
.rtl {
  direction: rtl;
  text-align: right;
}
</style>
